module.exports = __webpack_public_path__ + "img/fi_intro.f906b6f9.png";